import MasterLoadingComponent from './MasterLoadingComponent';
export default MasterLoadingComponent;



//////////////////
// WEBPACK FOOTER
// ./src/components/masterLoading/index.ts
// module id = 400
// module chunks = 50